import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-haberes',
  templateUrl: './main-haberes.component.html',
  styleUrls: ['./main-haberes.component.css']
})
export class MainAsignarHaberesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}